import { Box, BoxProps, Divider, Grid, GridItem, Text, VStack } from '@chakra-ui/react';
import { GoodToKnowItem } from 'api/responseTypes';

interface GoodToKnowCardProps extends Omit<BoxProps, 'children'> {
  items: GoodToKnowItem[];
  textColor?: string;
  bg?: string;
}

export const GoodToKnowCard = ({ items, textColor, bg, ...boxProps }: GoodToKnowCardProps) => {
  return (
    <Box
      mx='auto'
      maxW='1440px'
      px={{ base: '16px', md: '24px' }}
      py={{ base: '24px', md: '32px' }}
      bg='BG100'
      dir='rtl'
      {...boxProps}
    >
      <Grid
        templateColumns={{ base: '1fr', md: '1fr 1fr' }}
        gap={{ base: '16px', md: '24px' }}
        w='100%'
      >
        {items.map((item, index) => (
          <GridItem key={index}>
            <Box
              bg={bg || 'white'}
              borderRadius='12px'
              p={{ base: '20px', md: '24px' }}
              boxShadow='0 2px 8px rgba(0, 0, 0, 0.05)'
              borderWidth='1px'
              borderColor='dark.D100'
              transition='all 0.2s ease'
              _hover={{
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                transform: 'translateY(-2px)',
              }}
            >
              <VStack align='start' spacing='12px' width={'full'}>
                <Text
                  textStyle='headingMedium'
                  color={textColor || 'dark.D900'}
                  fontWeight='600'
                  lineHeight='1.2'
                  textAlign='right'
                >
                  {item.title}
                </Text>
                <Divider width={'80%'} />
                {item.description && (
                  <Text
                    textStyle='bodyLargeRegular'
                    color={textColor || 'dark.D600'}
                    lineHeight='1.6'
                    mt='4px'
                    textAlign='right'
                    whiteSpace='pre-line'
                  >
                    {item.description}
                  </Text>
                )}
              </VStack>
            </Box>
          </GridItem>
        ))}
      </Grid>
    </Box>
  );
};
